export default "__VITE_ASSET__CBi1eGKO__"